module.exports = __webpack_public_path__ + "static/media/cross_clean_grid.80b4ca89.jpg";